import Instance from '../../../Axios';

const EditarParceiros = (ydata, id) => async (dispatch) => {
  console.log(ydata, id);
  await Instance()
    .put(`/backend/parceiros/${id}`, { ydata })
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'PUT_PARCEIRO', payload: data });
      //   show('success', 'Foram associados novos funcionários á obra');
    })
    .catch((err) => {
      // eslint-disable-next-line eqeqeq
      if (err.response.status != 200) {
        // show('warning', 'Preencha todos os campos');
      }
    });
};

export default EditarParceiros;
